module.exports = __webpack_public_path__ + "static/media/REAPTLALPAN.0f0b79cb.jpg";